import {
    CAPTCHA_CONTAINER,
    CAPTCHA_SCRIPT_ID,
    CAPTCHA_SCRIPT_SRC,
    CAPTCHA_SITE_KEY,
} from 'modules/yandexSmartCaptcha/constants';
import {TSubscribeEvent} from 'modules/yandexSmartCaptcha/types';
import {FormEventHandler} from 'react';

export class CaptchaService {
    public static connectScript = (): Promise<boolean> => {
        return new Promise((resolve) => {
            if (document.querySelector(`#${CAPTCHA_SCRIPT_ID}`) || global.smartCaptcha !== undefined) {
                resolve(true);
                return;
            }

            const scriptTag = CaptchaService.prepareScriptTag();

            scriptTag.addEventListener('load', () => {
                if (global !== undefined) {
                    resolve(true);
                    return;
                }
                resolve(false);
            });
            scriptTag.addEventListener('error', () => resolve(false));

            CaptchaService.attachScript(scriptTag);
            resolve(true);
        });
    };

    public static prepareScriptTag = (): HTMLScriptElement => {
        // Основная часть скрипта
        /* eslint-disable camelcase */
        /* eslint-disable @typescript-eslint/naming-convention */
        const script = document.createElement('script');
        script.id = CAPTCHA_SCRIPT_ID;
        script.type = 'text/javascript';
        script.defer = true;
        script.src = CAPTCHA_SCRIPT_SRC;
        const s = document.getElementsByTagName('script')[0];
        s.parentNode?.insertBefore(script, s);
        return script;
    };

    public static attachScript(script: HTMLScriptElement): void {
        document.body.append(script);
    }

    public static renderCaptcha = <Cb,>(cb: Cb): string | undefined => {
        if (!global.smartCaptcha) {
            return;
        }

        // eslint-disable-next-line consistent-return
        return global.smartCaptcha.render(CAPTCHA_CONTAINER, {
            callback: cb,
            hideShield: true,
            invisible: true,
            sitekey: CAPTCHA_SITE_KEY,
        });
    };

    public static destroyCaptcha = (id?: string) => {
        if (!global.smartCaptcha) {
            return;
        }

        global.smartCaptcha.destroy(id);
    };
    public static resetCaptcha = (id?: string) => {
        if (!global.smartCaptcha) {
            return;
        }

        global.smartCaptcha.reset(id);
    };

    public static subscribeCaptcha = <Cb,>(id: string, event: TSubscribeEvent, cb: Cb): (() => void) | undefined => {
        if (!global.smartCaptcha) {
            return;
        }

        // eslint-disable-next-line consistent-return
        return global.smartCaptcha.subscribe<Cb>(id, event, cb);
    };

    public static executeCaptcha =
        (widgetId?: string): FormEventHandler<HTMLFormElement> =>
        (event) => {
            event.preventDefault();

            if (!global.smartCaptcha) {
                return;
            }

            global.smartCaptcha.execute(widgetId);
        };
}
